module.exports = __webpack_public_path__ + "static/media/car.93e75012.svg";